import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function EmptyAssetState() {
  const navigate = useNavigate();
  
  return (
    <div className="text-center mt-8">
      <p className="text-sm text-gray-500">No assets found.</p>
      <Button
        variant="outline"
        className="mt-4"
        onClick={() => navigate("/assets/new")}
      >
        <Plus className="mr-2 h-4 w-4" />
        Create your first asset
      </Button>
    </div>
  );
}